import script from "./StampSureDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./StampSureDialog.vue?vue&type=script&setup=true&lang=ts"

import "./StampSureDialog.vue?vue&type=style&index=0&id=623cf5eb&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623cf5eb"]])

export default __exports__